import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

interface CartQueryResponse {
  loading: boolean;
  error?: any;
  data?: any;
}

const QUERY = gql`
  query {
    cart {
      id
      hasUser
      loginRequired
      hasShippingAddress
      hasBillingAddress
      shippingRequired
      poNumber
      items {
        product {
          id
          name
          sku
          set
          setType
          inventoryCount
          physical
          attributes {
            code
            value
          }
          variants {
            type
            name
            price
          }
          media {
            type
            url
          }
        }
        price
        quantity
        format
        fixedQuantity
        maxQuantity
        removable
        items {
          product {
            id
            name
            sku
            set
            setType
            inventoryCount
            physical
            attributes {
              code
              value
            }
            variants {
              type
              name
              price
            }
            media {
              type
              url
            }
          }
          price
          quantity
          fixedQuantity
          format
        }
        attributes {
          code
          value
        }
      }
      discount {
        code
      }
      discounts {
        code
        used
        type
        value
        application {
          type
          id
        }
      }
      errors {
        type
        message
      }
      totals {
        subtotal
        shipping
        handling
        tax
        grandTotal
      }
      shippingAddress {
        attention
        company
        address1
        address2
        county
        city
        state
        postalCode
        country
        phone
        email
      }
      shippingRates {
        id
        cost
        carrier
        name
      }
      billingAddress {
        attention
        company
        address1
        address2
        county
        city
        state
        postalCode
        country
        phone
        email
      }
      secureToken {
        id
        value
      }
      shippingOption {
        id
      }
      steps {
        id
        open
        complete
        revisitAllowed
        error
      }
    }
  }
`;

const useCart = (): CartQueryResponse => {
  return useQuery(QUERY);
};

export default useCart;
